<template>
  <d-card>
    <d-card-row>
      <b-message
        has-icon
        type="is-info"
      >
        <p>{{ $t('onboarding.start.login.notice') }}</p>
        <p>
          {{ $t('onboarding.start.login.notice_2') }}
          <a href="/forgot-password">{{ $t('onboarding.reset_your_password') }}</a>
        </p>
      </b-message>
    </d-card-row>
    <d-card-row>
      <v-form
        :data="form"
        method="post"
        :url="$laravel.route('login')"
        :on-success="onSuccess"
      >
        <v-input
          v-model="form.email"
          type="email"
          name="email"
        />

        <v-input
          v-model="form.password"
          type="password"
          :autofocus="true"
          name="password"
        />

        <div class="buttons">
          <button
            class="button is-text"
            type="button"
            @click="$emit('back')"
          >
            <span class="icon">
              <i class="mdi mdi-arrow-left" />
            </span>
            <span>{{ $t('try_another_email') }}</span>
          </button>
          <button class="button is-primary">
            <span>{{ $t('login') }}</span>
            <span class="icon">
              <i class="mdi mdi-arrow-right" />
            </span>
          </button>
        </div>
      </v-form>
    </d-card-row>
  </d-card>
</template>

<script>
export default {
  props: {
    email: {
      default: "",
      type: String
    }
  },
  data () {
    return {
      form: {
        email: this.email,
        password: null,
      }
    };
  },
  watch: {
    email () {
      this.form.email = this.email;
    }
  },
  methods: {
    onSuccess () {
      this.$refresh();
    }
  }
};
</script>
